import React, { useState, useEffect } from "react";
import { withApollo } from "react-apollo";
import { Grid, withStyles, InputLabel, Link } from "@material-ui/core";
import TextField from "@jll/textfield";
import MButton from "@material-ui/core/Button";
import SearchIcon from "@material-ui/icons/Search";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import styles from "./styles";
import { getListValues } from "../../../../API/List";
import SearchableSelect from "../../../../Component/Forms/SearchableSelect";
import { useTranslation } from "react-i18next";

const SearchPanel = (props) => {
  const { classes, onSearch, onNewRecord, searching, onDnbSearch, searchQuery } = props;
  const { t } = useTranslation();
  const [companyName, setCompanyName] = useState();
  const [companyNameError, setCompanyNameError] = useState();
  const [companyNameErrorMessage, setCompanyNameErrorMessage] = useState();
  const [dunsNumber, setDunsNumber] = useState();
  const [dunsNumberError, setDunsNumberError] = useState();
  const [dunsNumberErrorMessage, setDunsNumberErrorMessage] = useState();
  const [advanceView, setAdvanceView] = useState(false);
  const [countryList, setCountryList] = useState([]);
  const [city, setCity] = useState();
  const [selectedCountry, setSelectedCountry] = useState();
  const [stateProvince, setStateProvince] = useState();
  const [postCode, setPostCode] = useState();
  const [loading, setIsLoading] = useState(false);

  useEffect(() => {
    const loadCountries = async () => {
      setIsLoading(true);
      try {
        const resuts = await getListValues({ listType: "CL" });
        const { data = [] } = resuts;
        setCountryList(
          data.map((c) => {
            return { value: c.code, label: c.value, isoCode2: c.isoCode2 };
          })
        );
      } catch (error) {
        setIsLoading(false);
      }
      setIsLoading(false);

    };
    loadCountries();
  }, []);

  useEffect(() => {
    if (searchQuery) {
      setCompanyName(searchQuery);
      onSearch({
        companyName: searchQuery,
      });
    }
  }, [searchQuery]);

  const validateSearchCriteria = () => {
    if (!companyName && !dunsNumber) {
      setCompanyNameError(true);
      setCompanyNameErrorMessage(t("messages.record.search.nameOrDunsError"));
      setDunsNumberError(true);
      setDunsNumberErrorMessage(t("messages.record.search.nameOrDunsError"));
      return false;
    } else if (dunsNumber) {
      const testDunsResult = /^(\d{9})|(\d{2}-\d{3}-\d{4})$/.test(dunsNumber);
      var isNumber = !/\D/.test(dunsNumber);

      if (!testDunsResult || (isNumber && dunsNumber.length !== 9)) {
        setDunsNumberError(true);
        setDunsNumberErrorMessage(t("messages.record.search.dunsError"));
        return false;
      }
    }
    setCompanyNameError(false);
    setCompanyNameErrorMessage(null);
    setDunsNumberError(false);
    setDunsNumberErrorMessage(null);
    return true;
  };

  const search = () => {
    if (validateSearchCriteria() && onSearch) {
      onSearch({
        companyName,
        dunsNumber,
        city,
        countryCode: selectedCountry ? selectedCountry.isoCode2 : null,
        countryId: selectedCountry ? selectedCountry.value : null,
        state: stateProvince,
        postCode,
      });
    }
  };

  const toogleAdvanceSearch = (e) => {
    e.preventDefault()
    setAdvanceView(!advanceView);
  };

  const searchDnb = () => {
    if (validateSearchCriteria() && onSearch) {
      onDnbSearch({
        companyName,
        dunsNumber,
        city,
        countryCode: selectedCountry ? selectedCountry.isoCode2 : null,
        state: stateProvince,
        postCode,
      });
    }
  };

  return (
    <>
      <Grid container spacing={2} className={classes.pageSection}>
        <Grid item xs={12}>
          {t("labels.record.search.header")}
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <TextField
            type="text"
            name="companyName"
            id="companyName"
            fullWidth
            placeholder={t("labels.record.search.form.companyName")}
            hasError={companyNameError}
            helpText={companyNameErrorMessage}
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <TextField
            type="text"
            name="dunsNumber"
            id="dunsNumber"
            fullWidth
            placeholder={t("labels.record.search.form.dunsNumber")}
            hasError={dunsNumberError}
            helpText={dunsNumberErrorMessage}
            value={dunsNumber}
            onChange={(e) => setDunsNumber(e.target.value)}
          />
        </Grid>

        <Grid container item xs={12} sm={6} md={1} alignItems="flex-end" >
          <Link href="#" component="button" onClick={toogleAdvanceSearch}>
            {advanceView ? t("labels.record.search.hideMore") : t("labels.record.search.showMore")}
          </Link>
        </Grid>

        <Grid item xs={12} sm={6} md={1}>
          <MButton
            color="primary"
            variant="contained"
            label={t("labels.record.search.actions.search")}
            disabled={searching}
            onClick={search}
            style={{ height: 40 }}
          >
            <SearchIcon />
          </MButton>
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <MButton
            color="primary"
            variant="contained"
            label={t("labels.record.search.actions.searchD&B")}
            disabled={searching}
            onClick={searchDnb}
            style={{ height: 40 }}
          >
            <>
              <SearchIcon /> {t("labels.record.search.actions.searchD&B")}
            </>
          </MButton>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <MButton
            color="primary"
            variant="contained"
            style={{ height: 40, float: "right", marginRight: 15 }}
            onClick={onNewRecord}
          >
            {t("labels.record.search.actions.createNewRecord")}
          </MButton>
        </Grid>
      </Grid>

      {advanceView && (
        <Grid
          container
          direction="row"
          spacing={3}
          className={classes.AdvancePanel}
        >
          <Grid item sm={6} md={3} xs={12}>
            <InputLabel className={classes.inputLabel}>{t("labels.record.search.form.city")}</InputLabel>
            <TextField
              name="input_city"
              type="text"
              id="input_city"
              placeholder={t("labels.record.search.form.enterTownOrCity")}
              value={city}
              onChange={(e) => setCity(e.target.value)}
            />
          </Grid>

          <Grid item sm={6} md={3} xs={12}>
            <InputLabel className={classes.inputLabel}>
              {t("labels.record.search.form.stateOrProvince")}
            </InputLabel>
            <TextField
              name="input_stateProvince"
              type="text"
              id="input_stateProvince"
              placeholder={t("labels.record.search.form.enterStateProvince")}
              value={stateProvince}
              onChange={(e) => setStateProvince(e.target.value)}
            />
          </Grid>
          <Grid item sm={6} md={3} xs={12}>
            <InputLabel className={classes.inputLabel}>{t("labels.record.search.form.postCode")}</InputLabel>
            <TextField
              name="input_postcode"
              type="text"
              id="input_postcode"
              placeholder={t("labels.record.search.form.enterPostcode")}
              value={postCode}
              onChange={(e) => setPostCode(e.target.value)}
            />
          </Grid>
          <Grid item sm={6} md={3} xs={12}>
            <SearchableSelect
              label={t("labels.record.search.form.country")}
              options={countryList}
              value={selectedCountry}
              changeHandler={(e) => {
                setSelectedCountry(e);
              }}
            />
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default withApollo(withStyles(styles, { withTheme: true })(SearchPanel));
